"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveOfferToBasketModalSaga = saveOfferToBasketModalSaga;
var _react = _interopRequireDefault(require("react"));
var _effects = require("redux-saga/effects");
var _selectors = require("@otpusk/apisearch-toolbox/dist/queries/selectors");
var _selectors2 = require("@otpusk/apisearch-toolbox/dist/offers/selectors");
var R = _interopRequireWildcard(require("ramda"));
var _selectors3 = require("@otpusk/apisearch-toolbox/dist/services/selectors");
var _selectors4 = require("@otpusk/apisearch-toolbox/dist/geo/selectors");
var _services = require("@otpusk/apisearch-toolbox/dist/services");
var _geo = require("@otpusk/apisearch-toolbox/dist/geo");
var _helpers = require("@otpusk/apisearch-toolbox/dist/offers/helpers");
var _selectors5 = require("@otpusk/apisearch-toolbox/dist/hotels/selectors");
var _actions = require("@otpusk/apisearch-toolbox/dist/queries/actions");
var _fn = require("@otpusk/apisearch-toolbox/dist/queries/fn");
var _actions2 = require("@otpusk/apisearch-toolbox/dist/search/actions");
var _selectors6 = require("@otpusk/apisearch-toolbox/dist/search/selectors");
var _api = require("../../../../helpers/api");
var _handlers = require("../../../../helpers/handlers");
var _saga = require("../../../Baskets/store/saga");
var _actions3 = require("../../../Baskets/store/actions");
var _selectors7 = require("../../../Baskets/store/selectors");
var _actions4 = require("../../../Search/store/actions");
var _constants = require("../../../Search/constants");
var _saga2 = require("../../../Search/store/saga");
var _ConfirmModal = require("../../../ConfirmModal");
var _config = require("../../../../services/config");
var _actions5 = require("../../../../bus/ui/actions");
var _actions6 = require("../../../../modalDispatcher/store/actions");
var _loader = _interopRequireDefault(require("../../../../modalDispatcher/loader"));
var _selectors8 = require("../../../../modalDispatcher/store/selectors");
var _localization = _interopRequireDefault(require("../../../../localization"));
var _helpers2 = require("../helpers");
var _selectors9 = require("./selectors");
var _constants2 = require("./constants");
var _actions7 = require("./actions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _marked = /*#__PURE__*/_regeneratorRuntime().mark(initAutoCloseModalSaga),
  _marked2 = /*#__PURE__*/_regeneratorRuntime().mark(saveOfferToBasketModalSaga);
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var showModal = (0, _loader.default)({
  key: _constants2.SAVE_OFFER_TO_BASKET_MODAL_KEY,
  getModal: function getModal() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require(/* save-offer-to-basket-modal */"../SaveOfferToBasketModal"));
    });
  }
});
var DEFAULT_COUNTRY = 0;
function showSaveOfferToBasketModalSaga(_ref) {
  var _ref$payload = _ref.payload,
    callbacks = _ref$payload.callbacks,
    offerID = _ref$payload.offerID,
    queryID = _ref$payload.queryID;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var isOpenWithOffer, isEmptyAllServices, isEmptyOperators, error;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)((0, _actions6.setup)(_constants2.BOOTSTRAP_UI));
        case 2:
          _context.next = 4;
          return (0, _effects.put)((0, _actions5.register)(_constants2.BOOTSTRAP_UI, {
            loading: true
          }));
        case 4:
          isOpenWithOffer = offerID && queryID;
          _context.prev = 5;
          _context.next = 8;
          return (0, _effects.select)(R.pipe(_selectors3.getAllServices, R.isEmpty));
        case 8:
          isEmptyAllServices = _context.sent;
          _context.next = 11;
          return (0, _effects.select)(function (state) {
            return R.isEmpty((0, _selectors4.getOperators)()(state, {
              key: DEFAULT_COUNTRY
            }));
          });
        case 11:
          isEmptyOperators = _context.sent;
          _context.next = 14;
          return (0, _effects.all)([isEmptyAllServices && (0, _effects.put)(_services.servicesActions.getServices(0)), isEmptyOperators && (0, _effects.put)(_geo.geoActions.getOperators(0))]);
        case 14:
          _context.next = 16;
          return (0, _effects.all)([isEmptyAllServices && (0, _effects.race)([(0, _effects.take)(_services.servicesActions.getServicesSuccess), (0, _effects.take)(_services.servicesActions.getServicesFail)]), isEmptyOperators && (0, _effects.race)([(0, _effects.take)(_geo.geoActions.getOperatorsSuccess), (0, _effects.take)(_geo.geoActions.getOperatorsFail)])]);
        case 16:
          _context.next = 18;
          return (0, _effects.call)(_saga.getBasketsSimplifiedSaga, (0, _actions3.getBasketsSimplified)(1, isOpenWithOffer ? undefined : _constants2.COUNT_BASKETS_SIMPLIFIED_WITHOUT_OFFER));
        case 18:
          _context.next = 20;
          return (0, _effects.put)(showModal(undefined, {
            offerID: offerID
          }, isOpenWithOffer ? {
            onCreateBasketWithOffer: function onCreateBasketWithOffer(dispatch) {
              dispatch((0, _actions7.createBasketWithOffer)(offerID, queryID));
            },
            onAddOfferToBasket: function onAddOfferToBasket(dispatch, _, basketID) {
              var callbacksOfAddOffer2Basket = {
                onSuccess: function onSuccess() {
                  callbacks === null || callbacks === void 0 ? void 0 : callbacks.onSuccessSavedOfferToBasket();
                }
              };
              dispatch((0, _actions7.addOfferToBasket)(offerID, basketID, queryID, callbacksOfAddOffer2Basket));
            },
            onRemoveOfferFromBasket: function onRemoveOfferFromBasket(dispatch, _, basketID) {
              var callbackOfRemoveOfferFromBasket = {
                onSuccess: callbacks === null || callbacks === void 0 ? void 0 : callbacks.onSuccessRemovedOfferFromBasket
              };
              dispatch((0, _actions7.removeOfferFromBasket)(offerID, basketID, callbackOfRemoveOfferFromBasket));
            }
          } : {
            onSetBasket: function onSetBasket(dispatch, _, basketID) {
              dispatch((0, _actions7.getActiveBasket)(basketID));
            }
          }));
        case 20:
          if (!isOpenWithOffer) {
            _context.next = 23;
            break;
          }
          _context.next = 23;
          return (0, _effects.put)((0, _actions7.initAutoCloseModal)());
        case 23:
          _context.next = 32;
          break;
        case 25:
          _context.prev = 25;
          _context.t0 = _context["catch"](5);
          _context.next = 29;
          return (0, _effects.call)(_api.getErrorMessage, _context.t0);
        case 29:
          error = _context.sent;
          _context.next = 32;
          return (0, _effects.put)((0, _actions5.update)(_constants2.BOOTSTRAP_UI, {
            error: error
          }));
        case 32:
          _context.prev = 32;
          _context.next = 35;
          return (0, _effects.put)((0, _actions5.update)(_constants2.BOOTSTRAP_UI, {
            loading: false,
            completed: true
          }));
        case 35:
          return _context.finish(32);
        case 36:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[5, 25, 32, 36]]);
  })();
}
var DEFAULT_PAGE = 1;
function addOfferToBasketSaga(_ref2) {
  var _ref2$payload = _ref2.payload,
    offerID = _ref2$payload.offerID,
    queryID = _ref2$payload.queryID,
    basketID = _ref2$payload.basketID,
    callbacks = _ref2$payload.callbacks;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var callback, uiKey, query, offer, _extractDataFromOffer, baseOfferID, _yield$call, extraOfferID, _yield$call$basket, date, title, image, message;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          callback = (0, _config.getOnAddOfferToBasket)();
          if (!callback) {
            _context2.next = 39;
            break;
          }
          uiKey = (0, _helpers2.getAddOfferToBasketUIKey)(basketID);
          _context2.next = 5;
          return (0, _effects.put)((0, _actions5.register)(uiKey, {
            loading: true
          }));
        case 5:
          _context2.next = 7;
          return (0, _effects.select)(function (state) {
            return (0, _selectors.getQuery)(state, {
              queryID: queryID
            });
          });
        case 7:
          query = _context2.sent;
          _context2.next = 10;
          return (0, _effects.select)(function (state) {
            return (0, _selectors2.getOffer)()(state, {
              offerID: offerID
            });
          });
        case 10:
          offer = _context2.sent;
          _extractDataFromOffer = (0, _helpers.extractDataFromOfferKey)(offerID), baseOfferID = _extractDataFromOffer.id;
          _context2.prev = 12;
          _context2.next = 15;
          return (0, _effects.call)(callback, offer, basketID, query.toJS());
        case 15:
          _yield$call = _context2.sent;
          extraOfferID = _yield$call.id;
          _yield$call$basket = _yield$call.basket;
          date = _yield$call$basket.date;
          title = _yield$call$basket.title;
          image = _yield$call$basket.image;
          _context2.next = 23;
          return (0, _effects.put)((0, _actions3.addOfferToSimplifyBasket)(basketID, {
            id: baseOfferID,
            extra: {
              id: extraOfferID
            }
          }));
        case 23:
          _context2.next = 25;
          return (0, _effects.put)((0, _actions3.updateSimplifyBasket)(basketID, {
            title: title,
            date: date,
            image: image
          }));
        case 25:
          callbacks === null || callbacks === void 0 ? void 0 : callbacks.onSuccess(offerID);
          _context2.next = 35;
          break;
        case 28:
          _context2.prev = 28;
          _context2.t0 = _context2["catch"](12);
          _context2.next = 32;
          return (0, _effects.call)(_api.getErrorMessage, _context2.t0);
        case 32:
          message = _context2.sent;
          _context2.next = 35;
          return (0, _effects.put)((0, _actions5.update)(uiKey, {
            error: true,
            message: message
          }));
        case 35:
          _context2.prev = 35;
          _context2.next = 38;
          return (0, _effects.put)((0, _actions5.update)(uiKey, {
            loading: false,
            completed: true
          }));
        case 38:
          return _context2.finish(35);
        case 39:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[12, 28, 35, 39]]);
  })();
}
function createBasketWithOfferSaga(_ref3) {
  var _ref3$payload = _ref3.payload,
    offerID = _ref3$payload.offerID,
    queryID = _ref3$payload.queryID,
    callbacks = _ref3$payload.callbacks;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    var _yield$call2, basketID, date, image, title, onAfterCreateBasketWithOffer, basket;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.put)((0, _actions5.setIsVisibleGlobalLoader)(true));
        case 2:
          _context3.prev = 2;
          _context3.next = 5;
          return (0, _effects.call)(_saga.createBasketSaga);
        case 5:
          _yield$call2 = _context3.sent;
          basketID = _yield$call2.id;
          date = _yield$call2.date;
          image = _yield$call2.image;
          title = _yield$call2.title;
          onAfterCreateBasketWithOffer = (0, _config.getOnCreateBasketWithOfferInModal)();
          basket = {
            id: basketID,
            date: date,
            image: image,
            offers: [],
            title: title
          };
          _context3.next = 14;
          return (0, _effects.put)((0, _actions3.addSimplifyBasket)(basket));
        case 14:
          _context3.next = 16;
          return (0, _effects.call)(addOfferToBasketSaga, (0, _actions7.addOfferToBasket)(offerID, basketID, queryID));
        case 16:
          if (!onAfterCreateBasketWithOffer) {
            _context3.next = 19;
            break;
          }
          _context3.next = 19;
          return (0, _effects.put)((0, _ConfirmModal.showConfirmModal)(undefined, {
            header: _localization.default.t('SAVE_OFFER_TO_BASKET_MODAL:REDIRECT_TO_DETAIL_PAGE_MODAL_HEADER'),
            content: /*#__PURE__*/_react.default.createElement("a", {
              href: "#",
              onClick: (0, _handlers.handleWith)(_handlers.prevent, onAfterCreateBasketWithOffer)
            }, _localization.default.t('SAVE_OFFER_TO_BASKET_MODAL:REDIRECT_TO_DETAIL_PAGE_MODAL_CONTENT')),
            confirmButtonText: _localization.default.t('SAVE_OFFER_TO_BASKET_MODAL:REDIRECT_TO_DETAIL_PAGE_MODAL_BUTTON'),
            cancelButton: false
          }));
        case 19:
          callbacks === null || callbacks === void 0 ? void 0 : callbacks.onSuccess();
          _context3.next = 25;
          break;
        case 22:
          _context3.prev = 22;
          _context3.t0 = _context3["catch"](2);
          console.log(_context3.t0);
        case 25:
          _context3.prev = 25;
          _context3.next = 28;
          return (0, _effects.put)((0, _actions5.setIsVisibleGlobalLoader)(false));
        case 28:
          return _context3.finish(25);
        case 29:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[2, 22, 25, 29]]);
  })();
}
function removeOfferFromBasketSaga(_ref4) {
  var _ref4$payload = _ref4.payload,
    offerID = _ref4$payload.offerID,
    basketID = _ref4$payload.basketID,
    callbacks = _ref4$payload.callbacks;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    var transport, _yield$select, id;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          transport = (0, _config.getOnRemoveOfferFromBasket)();
          if (!transport) {
            _context4.next = 11;
            break;
          }
          _context4.next = 4;
          return (0, _effects.select)(function (state) {
            return (0, _selectors7.getSimplifiedOfferExtra)(state, {
              basketID: basketID,
              offerID: offerID
            });
          });
        case 4:
          _yield$select = _context4.sent;
          id = _yield$select.id;
          _context4.next = 8;
          return (0, _effects.call)(transport, id, basketID);
        case 8:
          _context4.next = 10;
          return (0, _effects.put)((0, _actions3.removeOfferFromSimplifyBasket)(offerID, basketID));
        case 10:
          callbacks === null || callbacks === void 0 ? void 0 : callbacks.onSuccess(offerID);
        case 11:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  })();
}
function removeOfferFromActiveBasketSaga(_ref5) {
  var _ref5$payload = _ref5.payload,
    offerID = _ref5$payload.offerID,
    basketID = _ref5$payload.basketID;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
    var _extractDataFromOffer2, baseOfferID;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _extractDataFromOffer2 = (0, _helpers.extractDataFromOfferKey)(offerID), baseOfferID = _extractDataFromOffer2.id;
          _context5.next = 3;
          return (0, _effects.all)([(0, _effects.put)((0, _actions3.removeOfferFromSimplifyBasket)(baseOfferID, basketID)), (0, _effects.put)((0, _actions3.startRemoveOfferFromBasket)(offerID, basketID))]);
        case 3:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  })();
}
function startSearchByOfferSaga(_ref6) {
  var _ref6$payload = _ref6.payload,
    hotelID = _ref6$payload.hotelID,
    offerID = _ref6$payload.offerID;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
    var setQueries, _iterator, _step, _loop, hotel, offer, query;
    return _regeneratorRuntime().wrap(function _callee6$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.put)((0, _actions5.setIsVisibleGlobalLoader)(true));
        case 2:
          _context7.next = 4;
          return (0, _effects.select)(function (state) {
            return R.filter(function (queryID) {
              return Boolean((0, _selectors.getQuery)(state, {
                queryID: queryID
              }));
            }, _constants.MAIN_QUERIES);
          });
        case 4:
          setQueries = _context7.sent;
          _iterator = _createForOfIteratorHelper(setQueries);
          _context7.prev = 6;
          _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop() {
            var queryID, shouldCancelSearch, isBase;
            return _regeneratorRuntime().wrap(function _loop$(_context6) {
              while (1) switch (_context6.prev = _context6.next) {
                case 0:
                  queryID = _step.value;
                  _context6.next = 3;
                  return (0, _effects.select)(function (state) {
                    return (0, _selectors6.isProccess)(state, {
                      queryID: queryID
                    });
                  });
                case 3:
                  shouldCancelSearch = _context6.sent;
                  if (!shouldCancelSearch) {
                    _context6.next = 7;
                    break;
                  }
                  _context6.next = 7;
                  return (0, _effects.put)(_actions2.searchActions.cancelledSearch(queryID));
                case 7:
                  _context6.next = 9;
                  return (0, _effects.put)(_actions2.searchActions.clearSearch(queryID));
                case 9:
                  isBase = queryID === _constants.MAIN_QUERY_ID;
                  if (isBase) {
                    _context6.next = 13;
                    break;
                  }
                  _context6.next = 13;
                  return (0, _effects.put)(_actions.queriesActions.removeQuery(queryID));
                case 13:
                case "end":
                  return _context6.stop();
              }
            }, _loop);
          });
          _iterator.s();
        case 9:
          if ((_step = _iterator.n()).done) {
            _context7.next = 13;
            break;
          }
          return _context7.delegateYield(_loop(), "t0", 11);
        case 11:
          _context7.next = 9;
          break;
        case 13:
          _context7.next = 18;
          break;
        case 15:
          _context7.prev = 15;
          _context7.t1 = _context7["catch"](6);
          _iterator.e(_context7.t1);
        case 18:
          _context7.prev = 18;
          _iterator.f();
          return _context7.finish(18);
        case 21:
          _context7.next = 23;
          return (0, _effects.select)(function (state) {
            return (0, _selectors5.getHotel)()(state, hotelID);
          });
        case 23:
          hotel = _context7.sent;
          _context7.next = 26;
          return (0, _effects.select)(function (state) {
            return (0, _selectors2.getOffer)()(state, {
              offerID: offerID
            });
          });
        case 26:
          offer = _context7.sent;
          _context7.next = 29;
          return (0, _effects.put)(_actions.queriesActions.createQueryFromOffer(_constants.MAIN_QUERY_ID, hotel, offer, _defineProperty(_defineProperty(_defineProperty({}, _fn.QUERY_PARAMS.AUTOSTART, true), _fn.QUERY_PARAMS.CURRENCY, offer.currencyLocal), _fn.QUERY_PARAMS.COUNTRY, hotel.country.id.toString())));
        case 29:
          _context7.next = 31;
          return (0, _effects.call)(_saga2.fetchDepthDataByCountryIDSaga, (0, _actions4.fetchDepthDataByCountryID)(_constants.MAIN_QUERY_ID));
        case 31:
          _context7.next = 33;
          return (0, _effects.put)((0, _actions6.close)(_constants2.SAVE_OFFER_TO_BASKET_MODAL_KEY));
        case 33:
          _context7.next = 35;
          return (0, _effects.put)((0, _actions6.destroy)(_constants2.SAVE_OFFER_TO_BASKET_MODAL_KEY));
        case 35:
          _context7.next = 37;
          return (0, _effects.select)(function (state) {
            return (0, _selectors.getQuery)(state, {
              queryID: _constants.MAIN_QUERY_ID
            });
          });
        case 37:
          query = _context7.sent;
          _context7.next = 40;
          return (0, _effects.put)((0, _actions5.setIsVisibleGlobalLoader)(false));
        case 40:
          _context7.next = 42;
          return (0, _effects.put)((0, _actions4.search)(_constants.MAIN_QUERY_ID, query.toJS()));
        case 42:
        case "end":
          return _context7.stop();
      }
    }, _callee6, null, [[6, 15, 18, 21]]);
  })();
}
function updateBasketTitleSaga(_ref7) {
  var payload = _ref7.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
    var basketID, title, onSuccess, callback;
    return _regeneratorRuntime().wrap(function _callee7$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          basketID = payload.basketID, title = payload.title, onSuccess = payload.onSuccess;
          callback = (0, _config.getOnUpdateBasket)();
          if (!callback) {
            _context8.next = 16;
            break;
          }
          _context8.prev = 3;
          _context8.next = 6;
          return (0, _effects.put)((0, _actions7.setActiveEditingBasketID)(basketID));
        case 6:
          _context8.next = 8;
          return (0, _effects.call)(callback, basketID, {
            title: title
          });
        case 8:
          // need to call before setActiveEditingBasketID
          // because editing control will mount and apply auto focus to input
          // after that onBlur will call
          // #42311
          onSuccess();
          _context8.next = 11;
          return (0, _effects.all)([(0, _effects.put)((0, _actions7.setPage)(DEFAULT_PAGE)), (0, _effects.put)((0, _actions7.setActiveEditingBasketID)(null)), (0, _effects.put)((0, _actions3.updateSimplifyBasket)(basketID, {
            title: title
          }))]);
        case 11:
          _context8.next = 16;
          break;
        case 13:
          _context8.prev = 13;
          _context8.t0 = _context8["catch"](3);
          console.log(_context8.t0);
        case 16:
        case "end":
          return _context8.stop();
      }
    }, _callee7, null, [[3, 13]]);
  })();
}
function getActiveBasketSaga(_ref8) {
  var basketID = _ref8.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
    var error, isSucceed;
    return _regeneratorRuntime().wrap(function _callee8$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.put)((0, _actions5.register)(_constants2.GET_ACTIVE_BASKET_UI, {
            loading: true
          }));
        case 2:
          _context9.next = 4;
          return (0, _effects.put)((0, _actions7.setActiveBasketID)(basketID));
        case 4:
          _context9.prev = 4;
          _context9.next = 7;
          return (0, _effects.call)(_saga.getBasketsSaga, (0, _actions3.getBaskets)({
            selection: basketID
          }));
        case 7:
          _context9.next = 9;
          return (0, _effects.put)((0, _actions5.update)(_constants2.GET_ACTIVE_BASKET_UI, {
            success: true
          }));
        case 9:
          _context9.next = 18;
          break;
        case 11:
          _context9.prev = 11;
          _context9.t0 = _context9["catch"](4);
          _context9.next = 15;
          return (0, _effects.call)(_api.getErrorMessage, _context9.t0);
        case 15:
          error = _context9.sent;
          _context9.next = 18;
          return (0, _effects.put)((0, _actions5.update)(_constants2.GET_ACTIVE_BASKET_UI, {
            error: error,
            success: false
          }));
        case 18:
          _context9.prev = 18;
          _context9.next = 21;
          return (0, _effects.select)(_selectors9.getIsSuccessedFetchActiveBasket);
        case 21:
          isSucceed = _context9.sent;
          _context9.next = 24;
          return (0, _effects.put)((0, _actions5.update)(_constants2.GET_ACTIVE_BASKET_UI, {
            loading: false,
            completed: true,
            animating: isSucceed
          }));
        case 24:
          return _context9.finish(18);
        case 25:
        case "end":
          return _context9.stop();
      }
    }, _callee8, null, [[4, 11, 18, 25]]);
  })();
}
function removeBasketSaga(_ref9) {
  var _ref9$payload = _ref9.payload,
    basketID = _ref9$payload.basketID,
    onSuccess = _ref9$payload.onSuccess;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
    var callback, error;
    return _regeneratorRuntime().wrap(function _callee9$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          callback = (0, _config.getOnRemoveBasket)();
          if (!callback) {
            _context10.next = 24;
            break;
          }
          _context10.prev = 2;
          _context10.next = 5;
          return (0, _effects.put)((0, _actions5.register)(_constants2.DELETE_ACTIVE_BASKET_UI, {
            loading: true
          }));
        case 5:
          _context10.next = 7;
          return (0, _effects.call)(callback, basketID);
        case 7:
          _context10.next = 9;
          return (0, _effects.put)((0, _actions3.removeSimplifyBasket)(basketID));
        case 9:
          _context10.next = 11;
          return (0, _effects.call)(onSuccess, basketID);
        case 11:
          _context10.next = 20;
          break;
        case 13:
          _context10.prev = 13;
          _context10.t0 = _context10["catch"](2);
          _context10.next = 17;
          return (0, _effects.call)(_api.getErrorMessage, _context10.t0);
        case 17:
          error = _context10.sent;
          _context10.next = 20;
          return (0, _effects.put)((0, _actions5.update)(_constants2.DELETE_ACTIVE_BASKET_UI, {
            error: error,
            success: false
          }));
        case 20:
          _context10.prev = 20;
          _context10.next = 23;
          return (0, _effects.put)((0, _actions5.update)(_constants2.DELETE_ACTIVE_BASKET_UI, {
            loading: false,
            completed: true
          }));
        case 23:
          return _context10.finish(20);
        case 24:
        case "end":
          return _context10.stop();
      }
    }, _callee9, null, [[2, 13, 20, 24]]);
  })();
}
var TIME_TO_CLOSE_MODAL = 2500;
function initAutoCloseModalSaga() {
  var _yield$select2, onClose;
  return _regeneratorRuntime().wrap(function initAutoCloseModalSaga$(_context11) {
    while (1) switch (_context11.prev = _context11.next) {
      case 0:
        _context11.next = 2;
        return (0, _effects.take)(_actions7.addOfferToBasket);
      case 2:
        _context11.next = 4;
        return (0, _effects.delay)(TIME_TO_CLOSE_MODAL);
      case 4:
        _context11.next = 6;
        return (0, _effects.select)(function (state) {
          return (0, _selectors8.getModal)(state, {
            key: _constants2.SAVE_OFFER_TO_BASKET_MODAL_KEY
          });
        });
      case 6:
        _yield$select2 = _context11.sent;
        onClose = _yield$select2.onClose;
        _context11.next = 10;
        return (0, _effects.put)((0, _actions6.close)(_constants2.SAVE_OFFER_TO_BASKET_MODAL_KEY));
      case 10:
        _context11.next = 12;
        return (0, _effects.put)((0, _actions6.destroy)(_constants2.SAVE_OFFER_TO_BASKET_MODAL_KEY));
      case 12:
        if (onClose) {
          // TODO onClose calls without params
          onClose();
        }
      case 13:
      case "end":
        return _context11.stop();
    }
  }, _marked);
}
function changePageSaga(_ref10) {
  var _ref10$payload = _ref10.payload,
    page = _ref10$payload.page,
    limit = _ref10$payload.limit;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
    var basket;
    return _regeneratorRuntime().wrap(function _callee10$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return (0, _effects.put)((0, _actions7.setPage)(page));
        case 2:
          _context12.next = 4;
          return (0, _effects.call)(_saga.fetchBasketsSimplified, page, limit);
        case 4:
          basket = _context12.sent;
          if (!basket) {
            _context12.next = 8;
            break;
          }
          _context12.next = 8;
          return (0, _effects.put)((0, _actions3.mergeBasketsSimplified)(basket));
        case 8:
        case "end":
          return _context12.stop();
      }
    }, _callee10);
  })();
}
function saveOfferToBasketModalSaga() {
  return _regeneratorRuntime().wrap(function saveOfferToBasketModalSaga$(_context14) {
    while (1) switch (_context14.prev = _context14.next) {
      case 0:
        _context14.next = 2;
        return (0, _effects.takeEvery)(_actions7.showSaveOfferToBasketModal, showSaveOfferToBasketModalSaga);
      case 2:
        _context14.next = 4;
        return (0, _effects.takeEvery)(_actions7.createBasketWithOffer, createBasketWithOfferSaga);
      case 4:
        _context14.next = 6;
        return (0, _effects.takeEvery)(_actions7.updateBasketTitle, updateBasketTitleSaga);
      case 6:
        _context14.next = 8;
        return (0, _effects.takeEvery)(_actions7.removeOfferFromBasket, removeOfferFromBasketSaga);
      case 8:
        _context14.next = 10;
        return (0, _effects.takeEvery)(_actions7.removeOfferFromActiveBasket, removeOfferFromActiveBasketSaga);
      case 10:
        _context14.next = 12;
        return (0, _effects.takeEvery)(_actions7.addOfferToBasket, addOfferToBasketSaga);
      case 12:
        _context14.next = 14;
        return (0, _effects.takeEvery)(_actions7.getActiveBasket, getActiveBasketSaga);
      case 14:
        _context14.next = 16;
        return (0, _effects.takeEvery)(_actions7.removeBasket, removeBasketSaga);
      case 16:
        _context14.next = 18;
        return (0, _effects.takeEvery)(_actions7.startSearchByOffer, startSearchByOfferSaga);
      case 18:
        _context14.next = 20;
        return (0, _effects.takeEvery)(_actions7.initAutoCloseModal, /*#__PURE__*/_regeneratorRuntime().mark(function initAutoCloseModalControllerSaga() {
          var saga;
          return _regeneratorRuntime().wrap(function initAutoCloseModalControllerSaga$(_context13) {
            while (1) switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return (0, _effects.fork)(initAutoCloseModalSaga);
              case 2:
                saga = _context13.sent;
                _context13.next = 5;
                return (0, _effects.take)(function (action) {
                  return R.and(R.equals(action.type, _actions6.close.toString()), R.equals(R.prop('key', action.payload), _constants2.SAVE_OFFER_TO_BASKET_MODAL_KEY));
                });
              case 5:
                _context13.next = 7;
                return (0, _effects.cancel)(saga);
              case 7:
              case "end":
                return _context13.stop();
            }
          }, initAutoCloseModalControllerSaga);
        }));
      case 20:
        _context14.next = 22;
        return (0, _effects.takeEvery)(_actions7.changePage, changePageSaga);
      case 22:
      case "end":
        return _context14.stop();
    }
  }, _marked2);
}